export default __webpack_public_path__ + "static/avatar-fa1606137c025177d2ad831bd85bc1ce.png";